import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomePageComponent } from './home-page/home-page.component';
import { PhoneOrVariantComponent } from './phone-or-variant/phone-or-variant.component';
import { BrandListComponent } from './brand-list/brand-list.component';
import { AllBrandsComponent } from './all-brands/all-brands.component';
import { NotFoundComponent } from './not-found/not-found.component';

const routes: Routes = [
  { path: 'quotazioni-cellulari-usati', component: AllBrandsComponent },
  { path: 'quotazione-cellulare/:brandId', component: BrandListComponent },
  { path: 'quotazione-cellulare/:brandId/:phoneId', component: PhoneOrVariantComponent },
  { path: 'quotazione-cellulare/:brandId/:phoneId/:variantNameId', component: PhoneOrVariantComponent },
  { path: 'storico-quotazioni',
      loadChildren: './../historical-prices-module/historical-prices.module#HistoricalPricesModule' },
  { path: '', component: HomePageComponent, pathMatch: 'full' },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class FonziRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/fonzi-module/fonzi.routing.module.ts